import Vuex, { mapGetters, StoreOptions, Getter, GetterTree, Store, Module, MutationTree } from 'vuex';
import { NavState } from './types';

const mutations: MutationTree<NavState> = {
  setState(state: NavState, val: any) {
    if (typeof val === 'object' && val.val) {
      state.state = val.val + (val.err ? ' ' + val.err : '');
    } else {
      state.state = String(val);
    }
  },
  clearState(state: NavState) {
    state.state = null;
  },

  showDialog(state: NavState, v) {
    const dialogs: any = state.dialogs;
    if (typeof v === 'string') {
      if (!(v in dialogs)) { throw new Error('Invalid dialog'); }
      dialogs[v] = true;
      return;
    }

    if (!v.name) { throw new Error('Invalid dialog'); }
    if (!(v.name in dialogs)) { throw new Error('Invalid dialog'); }
    // if not set, assume show. If set and === false, hide
    dialogs[v.name] = (!v.show || v.show !== false) ? false : true;
  },
};

export default mutations;
